import { Environment } from '../constants/environments';
import { readCredential } from './credentialsStorage';

const getIngCookieValue = (name: string) => {
  const { NODE_ENV, ENVIRONMENT } = Environment;
  const keyCookie = String(NODE_ENV) === 'homologation' ? `_${String(ENVIRONMENT)}_` : '_';
  const cookieName = `ing_1${keyCookie}${name}`;

  const fromCookie = document.cookie.split(';')
    .map(cookie => cookie.trim())
    .find(cookie => cookie.startsWith(`${cookieName}=`))
    ?.split('=')[1];

  if (fromCookie) return fromCookie;

  // Cookie missing: in a cross-site iframe the browser drops it on write. That is the
  // only case where `readCredential` returns anything — see credentialsStorage.ts.
  return readCredential(cookieName);
};

export default getIngCookieValue;
